import React, { useEffect, useState, useRef } from 'react';
import moment from 'moment';
import { Grid, CircularProgress } from '@material-ui/core';
import queryString from 'query-string';
import { withStyles } from '@material-ui/core/styles';
import Button from '../../components/Button';
import FilterBar from './components/filterBar';
import NotificationRow from './components/notificationRow';

import { fetchAllNotificationsSearch } from '../../services/api';
import * as authApi from '../../services/api/auth';
import DateSelect from '../../components/DateSelect';
import SearchIcon from '@material-ui/icons/Search';

function NotificationDashboard(props) {
  const {
    location,
    history,
    classes: { labelStyle },
    label = 'Notification Search',
    placeholder = 'Patient search...',
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState({});
  const [notifications, setNotifications] = useState([]);
  const [filterFunctions, setFilterFunctions] = useState({});
  const [moreNotificationsExist, setMoreNotificationsExist] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoadingSearch, setIsLoadingSearch] = useState(false);
  const [notificationDate, setNotificationDate] = useState('');
  const [dateLoader, setDateLoader] = useState(false);
  const [filterBox, setFilterBox] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [archieve, setArchieve] = useState(false);
  const [archieveLoader, setArchieveLoader] = useState(false);
  const archieveRef = useRef(true); // To track initial page render
  const searchTermRef = useRef(true); // To track initial page render
  let queryParams = queryString.parse(location.search);
  let queryParamsLength = Object.keys(queryParams).length;

  const updateFilters = (filters, turnOn) => {
    const nextFilterFunctions = { ...filterFunctions };
    for (let filter of filters) {
      const filterKey = filter.name;
      // if "turnOn" not specified, toggle
      if (turnOn === undefined) {
        if (nextFilterFunctions[filterKey])
          delete nextFilterFunctions[filterKey];
        else nextFilterFunctions[filterKey] = filter;
      } else if (turnOn) {
        nextFilterFunctions[filterKey] = filter;
      } else {
        delete nextFilterFunctions[filterKey];
      }
    }
    setFilterFunctions(nextFilterFunctions);
  };

  const useFilterFunctions = notification => {
    notification.shown = Object.values(filterFunctions).every(filter =>
      filter(notification)
    );
    return notification;
  };

  const updateNotification = notificationId => updatedFields => {
    setNotifications(
      notifications.map(notification => {
        if (notification.id === notificationId)
          return { ...notification, ...updatedFields };
        return notification;
      })
    );
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const user = await authApi.fetchCurrentUser();
      setCurrentUser(user);

      // if no query params have been set this will set them to default
      let queryParams = queryString.parse(location.search);

      // if (Object.keys(queryParams).length === 0) {

      //   queryParams.archived = false
      //   queryParams.types = 'message,cancellation,request,booking'

      //   if (curUser.isProvider) {
      //     queryParams['from-providers'] = true
      //   }

      //   queryParams = '?' + queryString.stringify(queryParams)

      //   history.push({ search: queryParams.slice(1) })
      //   requestNotifications(queryParams)

      // } else {

      //   requestNotifications(location.search)

      // }
      if (user.notificationFilterStatus) {
        queryParams.archived =
          user.notificationFilterStatus.archivedStatus || false;
        queryParams.types = user.notificationFilterStatus.messageStatus
          ? 'message'
          : '';
        queryParams.types = user.notificationFilterStatus.bookingStatus
          ? queryParams.types + ',booking'
          : queryParams.types;
        queryParams.types = user.notificationFilterStatus.cancelledStatus
          ? queryParams.types + ',cancellation'
          : queryParams.types;
        queryParams.types = user.notificationFilterStatus.requestStatus
          ? queryParams.types + ',request'
          : queryParams.types;
        if (user.isProvider) {
          queryParams['from-providers'] =
            user.notificationFilterStatus.fromProviderStatus || false;
        }
        if (
          queryParams.types === '' &&
          queryParams.archived === false &&
          queryParams['from-providers'] === false
        ) {
          queryParams.types = 'message';
        }
        let queryParamsData = '?' + queryString.stringify(queryParams);

        history.push({ search: queryParamsData.slice(1) });

        requestNotifications(queryParamsData);
      }

      //  const apiResponse = await fetchConsultNoteAttachments(note.id);

      //  const imageObjects = makeS3BlobsRenderable(apiResponse.data)

      //  setImages(imageObjects);
    })();
  }, []);

  useEffect(() => {
    if(!queryParamsLength){
      (async () => {
        setIsLoading(true);
        const user = await authApi.fetchCurrentUser();
        setCurrentUser(user);
  
        // if no query params have been set this will set them to default
        let queryParams = queryString.parse(location.search);

        if (user.notificationFilterStatus) {
          queryParams.archived =
            user.notificationFilterStatus.archivedStatus || false;
          queryParams.types = user.notificationFilterStatus.messageStatus
            ? 'message'
            : '';
          queryParams.types = user.notificationFilterStatus.bookingStatus
            ? queryParams.types + ',booking'
            : queryParams.types;
          queryParams.types = user.notificationFilterStatus.cancelledStatus
            ? queryParams.types + ',cancellation'
            : queryParams.types;
          queryParams.types = user.notificationFilterStatus.requestStatus
            ? queryParams.types + ',request'
            : queryParams.types;
          if (user.isProvider) {
            queryParams['from-providers'] =
              user.notificationFilterStatus.fromProviderStatus || false;
          }
          if (
            queryParams.types === '' &&
            queryParams.archived === false &&
            queryParams['from-providers'] === false
          ) {
            queryParams.types = 'message';
          }
          let queryParamsData = '?' + queryString.stringify(queryParams);
  
          history.push({ search: queryParamsData.slice(1) });
  
          requestNotifications(queryParamsData);
        }
      })();
    }
  }, [queryParamsLength]);

  useEffect(() => {
    (async () => {
      if (archieveRef.current || searchTermRef.current) {
        archieveRef.current = false;
        return; // To skip the effect on the first render
      }
      // setArchieveLoader(true);
      const user = await authApi.fetchCurrentUser();
      setCurrentUser(user);

      // if no query params have been set this will set them to default
      let queryParams = queryString.parse(location.search);

      // if (Object.keys(queryParams).length === 0) {

      //   queryParams.archived = false
      //   queryParams.types = 'message,cancellation,request,booking'

      //   if (curUser.isProvider) {
      //     queryParams['from-providers'] = true
      //   }

      //   queryParams = '?' + queryString.stringify(queryParams)

      //   history.push({ search: queryParams.slice(1) })
      //   requestNotifications(queryParams)

      // } else {

      //   requestNotifications(location.search)

      // }
      if (user.notificationFilterStatus) {
        queryParams.archived =
          user.notificationFilterStatus.archivedStatus || false;
        queryParams.types = user.notificationFilterStatus.messageStatus
          ? 'message'
          : '';
        queryParams.types = user.notificationFilterStatus.bookingStatus
          ? queryParams.types + ',booking'
          : queryParams.types;
        queryParams.types = user.notificationFilterStatus.cancelledStatus
          ? queryParams.types + ',cancellation'
          : queryParams.types;
        queryParams.types = user.notificationFilterStatus.requestStatus
          ? queryParams.types + ',request'
          : queryParams.types;
        if (user.isProvider) {
          queryParams['from-providers'] =
            user.notificationFilterStatus.fromProviderStatus || false;
        }
        if (
          queryParams.types === '' &&
          queryParams.archived === false &&
          queryParams['from-providers'] === false
        ) {
          queryParams.types = 'message';
        }
        let queryParamsData = '?' + queryString.stringify(queryParams);

        history.push({ search: queryParamsData.slice(1) });

        requestNotifications(queryParamsData);
      }

      //  const apiResponse = await fetchConsultNoteAttachments(note.id);

      //  const imageObjects = makeS3BlobsRenderable(apiResponse.data)

      //  setImages(imageObjects);
    })();
  }, [archieve]);

  useEffect(() => {
    (async () => {
      if (archieveRef.current || searchTermRef.current) {
        searchTermRef.current = false;
        return; // To skip the effect on the first render
      }
      if (searchTerm.length === 0) {
        setIsLoadingSearch(true);
        const user = await authApi.fetchCurrentUser();
        setCurrentUser(user);
        setIsLoadingSearch(false);
        let queryParams = queryString.parse(location.search);
        if (user.notificationFilterStatus) {
          queryParams.archived =
            user.notificationFilterStatus.archivedStatus || false;
          queryParams.types = user.notificationFilterStatus.messageStatus
            ? 'message'
            : '';
          queryParams.types = user.notificationFilterStatus.bookingStatus
            ? queryParams.types + ',booking'
            : queryParams.types;
          queryParams.types = user.notificationFilterStatus.cancelledStatus
            ? queryParams.types + ',cancellation'
            : queryParams.types;
          queryParams.types = user.notificationFilterStatus.requestStatus
            ? queryParams.types + ',request'
            : queryParams.types;
          if (user.isProvider) {
            queryParams['from-providers'] =
              user.notificationFilterStatus.fromProviderStatus || false;
          }
          if (
            queryParams.types === '' &&
            queryParams.archived === false &&
            queryParams['from-providers'] === false
          ) {
            queryParams.types = 'message';
          }
          delete queryParams['searchString'];
          let queryParamsData = '?' + queryString.stringify(queryParams);
          history.push({ search: queryParamsData.slice(1) });

          requestNotifications(queryParamsData);
        }
      }
    })();
  }, [searchTerm]);

  useEffect(() => {
    (async () => {
      if (notificationDate && notificationDate.length === 10) {
        const user = await authApi.fetchCurrentUser();
        setCurrentUser(user);
        setSearchTerm('');
        // if no query params have been set this will set them to default
        let queryParams = queryString.parse(location.search);
        if (user.notificationFilterStatus) {
          queryParams.archived =
            user.notificationFilterStatus.archivedStatus || false;
          queryParams.types = user.notificationFilterStatus.messageStatus
            ? 'message'
            : '';
          queryParams.types = user.notificationFilterStatus.bookingStatus
            ? queryParams.types + ',booking'
            : queryParams.types;
          queryParams.types = user.notificationFilterStatus.cancelledStatus
            ? queryParams.types + ',cancellation'
            : queryParams.types;
          queryParams.types = user.notificationFilterStatus.requestStatus
            ? queryParams.types + ',request'
            : queryParams.types;
          if (user.isProvider) {
            queryParams['from-providers'] =
              user.notificationFilterStatus.fromProviderStatus || false;
          }
          if (
            queryParams.types === '' &&
            queryParams.archived === false &&
            queryParams['from-providers'] === false
          ) {
            queryParams.types = 'message';
          }
          delete queryParams['searchString'];
          queryParams.filterDate = notificationDate;
          let queryParamsData = '?' + queryString.stringify(queryParams);
          history.push({ search: queryParamsData.slice(1) });

          requestNotifications(queryParamsData);
        }
      }
      if (notificationDate === 'Invalid date') {
        const user = await authApi.fetchCurrentUser();
        setCurrentUser(user);
        setSearchTerm('');
        // if no query params have been set this will set them to default
        let queryParams = queryString.parse(location.search);
        if (user.notificationFilterStatus) {
          queryParams.archived =
            user.notificationFilterStatus.archivedStatus || false;
          queryParams.types = user.notificationFilterStatus.messageStatus
            ? 'message'
            : '';
          queryParams.types = user.notificationFilterStatus.bookingStatus
            ? queryParams.types + ',booking'
            : queryParams.types;
          queryParams.types = user.notificationFilterStatus.cancelledStatus
            ? queryParams.types + ',cancellation'
            : queryParams.types;
          queryParams.types = user.notificationFilterStatus.requestStatus
            ? queryParams.types + ',request'
            : queryParams.types;
          if (user.isProvider) {
            queryParams['from-providers'] =
              user.notificationFilterStatus.fromProviderStatus || false;
          }
          if (
            queryParams.types === '' &&
            queryParams.archived === false &&
            queryParams['from-providers'] === false
          ) {
            queryParams.types = 'message';
          }
          delete queryParams['filterDate'];
          delete queryParams['searchString'];
          let queryParamsData = '?' + queryString.stringify(queryParams);

          history.push({ search: queryParamsData.slice(1) });

          requestNotifications(queryParamsData);
        }
      }
    })();
  }, [notificationDate]);

  const requestNotifications = async (queryParams, more = false) => {
    // setIsLoading(true);
    if (more && moreNotificationsExist) {
      const parsed = queryString.parse(queryParams);
      parsed.offset = notifications.length;
      // const nextNotifications = await fetchAllNotifications('?' + queryString.stringify(parsed));
      const nextNotifications = await fetchAllNotificationsSearch(
        '?' + queryString.stringify(parsed)
      );
      if (nextNotifications.length === 0) setMoreNotificationsExist(false);

      setNotifications([
        ...notifications,
        ...nextNotifications.map(notification => {
          notification.open = false;
          return notification;
        }),
      ]);
      setIsLoading(false);
    } else if (!more) {
      // const nextNotifications = await fetchAllNotifications(queryParams);
      const nextNotifications = await fetchAllNotificationsSearch(queryParams);
      if (nextNotifications.length === 0) setMoreNotificationsExist(false);

      setNotifications(
        nextNotifications.map(notification => {
          notification.open = false;
          return notification;
        })
      );
    }
    setIsLoading(false);
    setIsLoadingSearch(false);
    setDateLoader(false);
    setArchieve(false);
    setArchieveLoader(false);
  };

  const keyPress = e => {
    const re = /^[a-zA-Z ]*$/;
    if (!re.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleChange = async e => {
    setSearchTerm(e.target.value);
    setNotificationDate('');
  };

  const searchNotification = async () => {
    setIsLoadingSearch(true);
    const user = await authApi.fetchCurrentUser();
    setCurrentUser(user);
    let queryParams = queryString.parse(location.search);
    if (user.notificationFilterStatus) {
      queryParams.archived =
        user.notificationFilterStatus.archivedStatus || false;
      queryParams.types = user.notificationFilterStatus.messageStatus
        ? 'message'
        : '';
      queryParams.types = user.notificationFilterStatus.bookingStatus
        ? queryParams.types + ',booking'
        : queryParams.types;
      queryParams.types = user.notificationFilterStatus.cancelledStatus
        ? queryParams.types + ',cancellation'
        : queryParams.types;
      queryParams.types = user.notificationFilterStatus.requestStatus
        ? queryParams.types + ',request'
        : queryParams.types;
      if (user.isProvider) {
        queryParams['from-providers'] =
          user.notificationFilterStatus.fromProviderStatus || false;
      }
      if (
        queryParams.types === '' &&
        queryParams.archived === false &&
        queryParams['from-providers'] === false
      ) {
        queryParams.types = 'message';
      }
      if (searchTerm.length >= 0) {
        queryParams.searchString = searchTerm;
      }
      delete queryParams['filterDate'];
      let queryParamsData = '?' + queryString.stringify(queryParams);
      history.push({ search: queryParamsData.slice(1) });
      requestNotifications(queryParamsData);
    }
  };

  // const dateChange = (e, date) => {
  //   if (moment.utc(date).format("YYYY-MM-DD") !== 'Invalid date') {
  //     setNotificationDate(moment.utc(date).format("YYYY-MM-DD"))
  //     setSearchTerm('')
  //     setDateLoader(true)
  //   } if (date === null) {
  //     dateReset();
  //   }
  // }

  const dateReset = async () => {
    const user = await authApi.fetchCurrentUser();
    setCurrentUser(user);
    setSearchTerm('');
    setDateLoader(true);
    setNotificationDate('');
    // if no query params have been set this will set them to default
    let queryParams = queryString.parse(location.search);
    if (user.notificationFilterStatus) {
      queryParams.archived =
        user.notificationFilterStatus.archivedStatus || false;
      queryParams.types = user.notificationFilterStatus.messageStatus
        ? 'message'
        : '';
      queryParams.types = user.notificationFilterStatus.bookingStatus
        ? queryParams.types + ',booking'
        : queryParams.types;
      queryParams.types = user.notificationFilterStatus.cancelledStatus
        ? queryParams.types + ',cancellation'
        : queryParams.types;
      queryParams.types = user.notificationFilterStatus.requestStatus
        ? queryParams.types + ',request'
        : queryParams.types;
      if (user.isProvider) {
        queryParams['from-providers'] =
          user.notificationFilterStatus.fromProviderStatus || false;
      }
      if (
        queryParams.types === '' &&
        queryParams.archived === false &&
        queryParams['from-providers'] === false
      ) {
        queryParams.types = 'message';
      }
      delete queryParams['filterDate'];
      delete queryParams['searchString'];
      let queryParamsData = '?' + queryString.stringify(queryParams);

      history.push({ search: queryParamsData.slice(1) });

      requestNotifications(queryParamsData);
    }
  };

  const expandedClose = () => {
    setFilterBox(true);
  };

  const expandedCloseReturn = () => {
    setFilterBox(false);
  };

  return isLoadingSearch || dateLoader || isLoading ? (
    <Grid
      container
      justifyContent="center"
      alignContent="center"
      style={{ height: '100%' }}
    >
      <CircularProgress />
    </Grid>
  ) : (
    <div>
      <FilterBar
        requestNotifications={requestNotifications}
        indicateParamsChanged={() => setMoreNotificationsExist(true)}
        updateFilters={updateFilters}
        location={location}
        history={history}
        expandedClose={expandedClose}
      />
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item xs={12} md={6}>
          <div className="customInputWidth">
            <label className={labelStyle}>Notification Search</label>
            <input
              className="customInputStyle"
              type="text"
              onChange={handleChange}
              value={searchTerm}
              placeholder={placeholder}
              onKeyPress={keyPress}
              label={label}
            />
            <SearchIcon
              className="customSearchIcon"
              onClick={searchNotification}
            />
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
          style={{ marginBottom: '5px', overflow: 'hidden' }}
        >
          <DateSelect
            disableFuture
            fullWidth
            label="Search with date"
            format="MM/DD/YYYY"
            maxDate={moment()}
            placeholder="MM/DD/YYYY ex.10/02/1981"
            value={new Date(notificationDate)}
            onChange={date => {
              if (moment.utc(date).format('YYYY-MM-DD') !== 'Invalid date') {
                setNotificationDate(moment.utc(date).format('MM/DD/YYYY'));
                setSearchTerm('');
                setDateLoader(true);
              }
              if (date === null) {
                dateReset();
              }
            }}
          />
        </Grid>
      </Grid>
      
        {notifications
          .sort((n1, n2) => {
            return moment(n1.createdAt).isAfter(n2.createdAt) ? -1 : 1;
          })
          .map(useFilterFunctions)
          .map(
            (notification, i) =>
              notification.shown && (
                <NotificationRow
                  key={i}
                  currentUser={currentUser}
                  notification={notification}
                  updateNotification={updateNotification(notification.id)}
                  filterBoxEnable={filterBox}
                  expandedCloseReturn={expandedCloseReturn}
                  archieve={setArchieve}
                  setArchieveLoader={setArchieveLoader}
                  archieveLoader={archieveLoader}
                />
              )
          )}
      

      {moreNotificationsExist && (
          <Grid
            container
            justifyContent="center"
            alignContent="center"
            style={{ height: '100%' }}
          >
            <Button onClick={() => requestNotifications(location.search, true)}>
              More
            </Button>
          </Grid>
        )}
      {/* {isLoading ? (
        <Grid
          container
          justify="center"
          alignContent="center"
          style={{ height: '100%' }}
        >
          <CircularProgress />
        </Grid>
      ) : (
        moreNotificationsExist && (
          <Grid
            container
            justify="center"
            alignContent="center"
            style={{ height: '100%' }}
          >
            <Button onClick={() => requestNotifications(location.search, true)}>
              More
            </Button>
          </Grid>
        )
      )} */}
    </div>
  );
}

const styles = () => ({
  selectInput: {
    margin: '0.5em 1.5em 1.5em',
  },
  labelStyle: {
    padding: '25px',
  },
});

export default withStyles(styles)(NotificationDashboard);
